import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CaseFilter from './components/CaseFilter';
import CaseList from './components/CaseList';
import CaseCTA from './components/CaseCTA';

const CasesPage = () => {
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  return (
    <div className="min-h-screen bg-neutral-50">
      <Navbar />
      <main className="pt-20">
        {/* 页面标题区 */}
        <section className="bg-gradient-to-br from-[#1A3A5C] to-[#2A4A6C] py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-white mb-4">
                1039 成功案例
              </h1>
              <p className="text-xl text-white/90 mb-2">
                真实业务场景 · 可复制路径 · 合规落地
              </p>
              <p className="text-base text-white/70">
                找到与您业务相似的案例，快速判断 1039 适用性
              </p>
            </div>
          </div>
        </section>

        {/* 客户类型筛选区 */}
        <CaseFilter 
          selectedTypes={selectedTypes}
          onTypeChange={setSelectedTypes}
        />

        {/* 案例列表 */}
        <CaseList selectedTypes={selectedTypes} />

        {/* 行动引导区 */}
        <CaseCTA />
      </main>
      <Footer />
    </div>
  );
};

export default CasesPage;